import { create } from 'zustand';

interface TenantState {
  tenantId: string | null;
  name: string | null;
  slug: string | null;
  setTenant: (tenantId: string, name: string, slug?: string) => void;
  setTenantContext: (tenant: {
    tenantId?: string | null;
    name?: string | null;
    slug?: string | null;
  }) => void;
  clearTenant: () => void;
}

export const useTenantStore = create<TenantState>((set) => ({
  tenantId: null,
  name: null,
  slug: null,
  setTenant: (tenantId, name, slug) =>
    set({ tenantId, name, slug: slug ?? name?.toLowerCase() ?? null }),
  setTenantContext: ({ tenantId = null, name = null, slug = null }) =>
    set({
      tenantId,
      name,
      slug: slug ?? name?.toLowerCase() ?? null,
    }),
  clearTenant: () => set({ tenantId: null, name: null, slug: null }),
}));
